module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('loading', {
    attrs: {
      "is-loading": "is-loading"
    }
  }) : [_c('page-header', {
    attrs: {
      "title": "We'd love to know a bit more about you",
      "error": _vm.errorMessage
    }
  }), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "w-login-form__row"
  }, [_c('p', [_vm._v("Heya! We're working on improving some key areas of Teamwork and to ensure we offer the best version for your team, we'd love to know a few things about your \norganization. As you are an Administrator we thought you may be the best to help us.")])]), _c('div', {
    staticClass: "w-login-form__row"
  }, [_c('TwSelect', {
    attrs: {
      "label": "Industry category",
      "name": "industry-category",
      "options": _vm.industryCategoryOptions
    },
    model: {
      value: (_vm.model.industryCategory),
      callback: function($$v) {
        _vm.$set(_vm.model, "industryCategory", $$v)
      },
      expression: "model.industryCategory"
    }
  }), _c('TwSelect', {
    attrs: {
      "label": "Company size",
      "name": "company-size",
      "options": _vm.sizeOptions
    },
    model: {
      value: (_vm.model.size),
      callback: function($$v) {
        _vm.$set(_vm.model, "size", $$v)
      },
      expression: "model.size"
    }
  })], 1), _c('div', {
    staticClass: "w-login-form__row"
  }, [_c('p', [_vm._v("We appreciate your help on this,"), _c('br'), _vm._v("Dan & Peter.")])]), _c('button', {
    staticClass: "w-button w-button--blue",
    attrs: {
      "type": "submit"
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Save")])])])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a4c85c3","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sections/Login/CompanyInfo.vue
// module id = 587
// module chunks = 1